import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Universitat } from '../model/Universitat';
import { Trasllat } from '../model/trasllat';
import { EstudisRealitzats } from '../model/estudiRealitzat';
import { DocumentPreinscripcio } from '../model/documentPreinscripcio';
import { Alumne } from '../model/alumne';
import { Oferta } from '../model/oferta';
import { Login } from '../model/login';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BLTrasllat {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    get(login: Login, language: string): Promise<Trasllat> {
        const offset = new Date().getTimezoneOffset();
        console.log(login.dataNaixement);
        console.log(login.documentIdentificatiu);
        const url = 'trasllat?dataNaixement=' + login.dataNaixement +
            '&documentIdentificatiu=' + login.documentIdentificatiu +
            '&oferta=' + login.oferta.value.toString() +
            '&language=' + language;
        return this.getCall(url);
    }

    getFromPayWSToken(paywstoken: string): Promise<Trasllat> {
        const url = 'trasllat/token?paywstoken=' + paywstoken;
        return this.getCall(url);
    }

    getCall(url: string): Promise<Trasllat> {
        return new Promise<Trasllat>((resolve, reject) => {
            this.http.get<Trasllat>(
                this.dataService.getApiEndpoint(url)).subscribe(data => {
                    let json = JSON.stringify(data);
                    console.log(json);
                    const p = this.initializeTrasllat(data);
                    resolve(p);
                    console.log('Post-initialize');
                    json = JSON.stringify(p);
                    console.log(json);
                }, error => {
                    console.log(error);
                    reject(error.error);
                });
            });
    }

    initializeTrasllat(data: Trasllat): Trasllat {
        const p = new Trasllat();
        console.log('InitializeTrasllat');
        Object.assign(p, data); // Si es fa això sobreescriu els objectes de dins ...
        console.log(data);
        p.alumne = new Alumne();
        Object.assign(p.alumne, data.alumne);
        p.estudiRealitzat = new EstudisRealitzats();
        Object.assign(p.estudiRealitzat, data.estudiRealitzat);
        return p;
    }

    getDocuments(trasllat: Trasllat): Promise<DocumentPreinscripcio[]> {

        const pais = trasllat.estudiRealitzat.pais;
        const universitat = trasllat.estudiRealitzat.universitat;
        let url = 'trasllat/documents?oferta=' + trasllat.oferta.value.toString();
        if (pais != null && pais.value) {
            url += '&pais=' + pais.value;
        }
        if (universitat != null && universitat.value) {
            url += '&universitat=' + universitat.value;
        }
        url += '&language=' + trasllat.idioma;

        return new Promise<DocumentPreinscripcio[]>((resolve, reject) => {
            this.http.get<DocumentPreinscripcio[]>(
                this.dataService.getApiEndpoint(url)).subscribe(data => {
                    resolve(data);
                }, error => {
                    reject(error.error);
                });
            });
    }

    save(trasllat: Trasllat): Promise<Trasllat> {
        const json = JSON.stringify(trasllat);
        console.log(json);
        let url = 'trasllat?';
        url += 'language=' + trasllat.idioma;
        return new Promise<Trasllat>((resolve, reject) => {
            this.http.post<Trasllat>(this.dataService.getApiEndpoint(url), trasllat).subscribe(data => {
                const p = this.initializeTrasllat(data);
                resolve(p);
            }, error => {
                reject(error.error);
            });
        });
    }

    validaDNI(document: String): Observable<boolean> {
        const url = 'trasllat/IsValidDNI?document=' + document;
        return this.http.get<boolean>(this.dataService.getApiEndpoint(url));
    }

    validaNIE(document: String): Observable<boolean> {
        const url = 'trasllat/IsValidNIE?document=' + document;
        return this.http.get<boolean>(this.dataService.getApiEndpoint(url));
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/bltrasllat.ts